export default "__VITE_ASSET__gRZt85YB__ 600w";